import axios from "axios";
import { API_URL } from "App";

const api = axios.create();

export const fetchNewAlbum = async () => {
  const response = await api.get(`${API_URL}/album`);
  return response;
};
